import React, { useState } from "react";
import ChatFooter from "./ChatFooter";
import ChatHolder from "./ChatHolder";
import { SendType } from "./ChatFooter";
import {
  postAnnotationFilesService,
  getAnnotationFilesService,
} from "../../pdfEditor.api";
import { message } from "antd";
import { errorMessageHandler } from "../../../../constant/helper";
import { v4 as uuidv4 } from "uuid";
import { useDispatch } from "react-redux";
import {
  addBulkMessage,
  setMessagesLoading,
} from "../../../../actions/pdfMessages";
import { MessageType } from "../../../../constant/Types";
import ChatLoadingContextProvider from "../../../chat/ChatLoadingContextProvider";
import VoicePlayerContextProvider from "../../../chat/voicePlayer.context";

const Chat = ({ sessionId, uuid, consultationStatus }) => {
  const dispatch = useDispatch();

  const [sendType, setSendType] = useState(SendType.free);

  async function sendMessageHandler(messageType, messageData, options) {
    // dispatchEvent(true)
    dispatch(setMessagesLoading(true));

    let data = {
      clientMessageId: uuidv4(),
    };

    if (messageType === MessageType.client.voice) {
      data = {
        ...data,
        file: messageData,
        voiceDuration: options.duration,
      };
    } else {
      data = {
        ...data,
        text: messageData.text,
      };
    }

    await postAnnotationFilesService(sessionId, uuid, data)
      .then(async (res) => {
        const files = await getAnnotationFilesService(sessionId, uuid);

        dispatch(addBulkMessage(files.data));
      })
      .catch((error) => {
        message.error(errorMessageHandler(error));
      });

    dispatch(setMessagesLoading(false));

    setSendType(SendType.free);
  }

  return (
    <>
      <div className="pdfeditor__chat">
        <VoicePlayerContextProvider>
          <ChatLoadingContextProvider>
            <ChatHolder />
            <ChatFooter
              setSendType={setSendType}
              sendType={sendType}
              sendMessageHandler={sendMessageHandler}
              consultationStatus={consultationStatus}
            />
          </ChatLoadingContextProvider>
        </VoicePlayerContextProvider>
      </div>
    </>
  );
};

export default Chat;
